module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-152x152.c8160afbebcd1c1ee1406290a034cb25.png";